Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdminModuleStore = void 0;

exports.getAdminModuleStore = function (moduleId, adminCoreState) {
  if (!(moduleId in adminCoreState.modules)) {
    return;
  }

  return adminCoreState.modules[moduleId].store;
};